import http from "@/api/request";
import { USERS_SERVICE_BASE } from "@/config/apiBaseUrlConfig";

import type {
  AccountPageQueryRequest,
  InviteAccountResultVO,
  PageDataAccountPageVO,
  PageDataUserLoginLogVO,
  PageDataUserRealNameLogVO,
  UserBatchStatusUpdateRequest,
  UserDetailVO,
  UserLoginLogPageQueryRequest,
  UserPasswordResetRequest,
  UserRealNameLogPageQueryRequest,
  UserRealNameVO,
  UserStatusUpdateRequest,
  UserThirdBindLogVO,
  UserThirdBindRequest,
} from "./type";

/**
 * 分页查询用户列表
 * GET /service-chijing-users/api/user/getPage
 * @param params 分页与筛选条件
 */
export const getAccountPage = (params: AccountPageQueryRequest) => {
  return http.get<PageDataAccountPageVO>(`${USERS_SERVICE_BASE}/getPage`, {
    params,
  });
};

/**
 * 查询用户详情
 * GET /service-chijing-users/api/user/getUser/{id}
 * @param id 业务用户 ID
 */
export const getAccountDetail = (id: string) => {
  return http.get<UserDetailVO>(`${USERS_SERVICE_BASE}/getUser/${id}`);
};

/**
 * 查询当前实名信息
 * GET /service-chijing-users/api/user/getRealNameInfo/{id}
 * @param id 业务用户 ID
 */
export const getAccountRealNameInfo = (id: string) => {
  return http.get<UserRealNameVO>(`${USERS_SERVICE_BASE}/getRealNameInfo/${id}`);
};

/**
 * 用户登录日志分页查询
 * GET /service-chijing-users/api/user/getLoginLogPage
 * @param params 分页与筛选条件（Spring arg0 嵌套 query）
 */
export const getAccountLoginLogPage = (params: UserLoginLogPageQueryRequest) => {
  return http.get<PageDataUserLoginLogVO>(`${USERS_SERVICE_BASE}/getLoginLogPage`, {
    params,
  });
};

/**
 * 实名认证流水分页查询
 * GET /service-chijing-users/api/user/getRealNameLogPage
 * @param params 分页与筛选条件（Spring arg0 嵌套 query）
 */
export const getAccountRealNameLogPage = (params: UserRealNameLogPageQueryRequest) => {
  return http.get<PageDataUserRealNameLogVO>(`${USERS_SERVICE_BASE}/getRealNameLogPage`, {
    params,
  });
};

/**
 * 第三方绑定 / 解绑提交
 * POST /service-chijing-users/api/user/bindSubmit/{id}
 * @param id 业务用户 ID
 * @param data 绑定或解绑请求体
 */
export const submitAccountThirdBind = (id: string, data: UserThirdBindRequest) => {
  return http.post<UserThirdBindLogVO>(`${USERS_SERVICE_BASE}/bindSubmit/${id}`, data);
};

/**
 * 启用 / 禁用用户
 * PUT /service-chijing-users/api/user/updateStatus/{id}
 * @param id 业务用户 ID
 * @param data 目标账号状态
 */
export const updateAccountStatus = (id: string, data: UserStatusUpdateRequest) => {
  return http.put<UserDetailVO>(`${USERS_SERVICE_BASE}/updateStatus/${id}`, data);
};

/**
 * 批量启用 / 禁用用户
 * PUT /service-chijing-users/api/user/batchUpdateStatus
 * @param data 用户 ID 列表与目标账号状态
 */
export const batchUpdateAccountStatus = (data: UserBatchStatusUpdateRequest) => {
  return http.put<void>(`${USERS_SERVICE_BASE}/batchUpdateStatus`, data);
};

/**
 * 重置用户密码
 * PUT /service-chijing-users/api/user/resetPassword/{id}
 * @param id 业务用户 ID
 * @param data 新密码，不传则后端默认 123456
 */
export const resetAccountPassword = (id: string, data?: UserPasswordResetRequest) => {
  return http.put<void>(`${USERS_SERVICE_BASE}/resetPassword/${id}`, data ?? {});
};

/**
 * 获取平台邀请账号信息
 * GET /service-chijing-users/api/user/inviteAccount
 */
export const getAccountInviteInfo = () => {
  return http.get<InviteAccountResultVO>(`${USERS_SERVICE_BASE}/inviteAccount`);
};
